<template>
  <div class="issues-app-chat-sidebar-card"
       :class="[
        `issues-app-chat-sidebar-card_${color}`
      ]"
  >

    <div class="issues-app-chat-sidebar-card__header" v-if="$slots.header">
      <slot name="header"/>
    </div>

    <div class="issues-app-chat-sidebar-card__body">
      <slot />
    </div>

  </div>
</template>

<script>
  export default {
    name: "ChatSidebarCard",
    props: {
      color: {
        default: 'default'
      }
    }
  }
</script>

<style lang="scss">
  .issues-app-chat-sidebar-card {
    $border-radius: 3px;

    border-radius: $border-radius;

    &__header {
      display: inline-block;
      padding: 5px 10px;
      border-radius: #{$border-radius} 0 #{$border-radius} 0;
    }

    &__body {
      padding: 20px 10px;
    }

    &_danger {
      background: #FBE7E7;

      .issues-app-chat-sidebar-card__header {
        background: #F8D0D0;
        color: #E95C5C;
        font-weight: 500;
      }
    }


    &_warning {
      background: rgb(255,238, 173);

      .issues-app-chat-sidebar-card__header{
        background: #f5db77;
        font-weight: 500;
        color: #a5881b;
      }

      .v-select{
        background: #fff;
      }
    }

    &_info {
      background: rgb(208, 240, 254);

      .issues-app-chat-sidebar-card__header {
        background: #aed8e9;
        color: #38515d;
        font-weight: 500;
        font-size: 16px;
      }
    }

  }
</style>